module.exports = __webpack_public_path__ + "img/ss3.png";